export default {
  loading: false, // loading 加载的状态；
  isLogin: false,
  countInfo: {}, // 账号信息
  printConfig: { // 打印配置
    isReceipt: false, // 是否打印小票
    medicineValue: '-1', // 收费清单配置的打印机 // -1 是默认打印机的值
    scriptValue: '-1', // 处方单配置的打印机
    otherValue: '-1', // 诊疗费用单配置的打印机
    infusionValue: '-1', // 输液卡配置的打印机
    medicalRecordValue: '-1', // 门诊病历配置的打印机
  },
  windowHeight: 1000, // 浏览器高度
};
